import CompanyGroups from '@/pages/Admin/CompanyGroups'
import Configuration from '@/pages/Admin/Configuration'
import Users from '@/pages/Admin/Users'
import Tags from '@/pages/Admin/Tags'
import Companies from '@/pages/Admin/Companies'
import Numbers from '@/pages/Admin/Numbers'
import Lines from '@/pages/Admin/Lines'
import LineGroups from '@/pages/Admin/LineGroups'
import CompanyDelegations from '@/pages/Admin/CompanyDelegations'

export default [
  {
    path: '/admin/users',
    name: 'Users',
    component: Users,
    meta: {
      title: 'titles.admin.users',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/admin/tags',
    name: 'Tags',
    component: Tags,
    meta: {
      title: 'titles.admin.tags',
      requiresAuth: true,
      roles: [ 'COMPANY_ADMIN', 'COMPANY_USER' ]
    }
  },
  {
    path: '/admin/companies',
    name: 'Companies',
    component: Companies,
    meta: {
      title: 'titles.admin.companies',
      requiresAuth: true,
      roles: [ 'GROUP_ADMIN' ]
    }
  },
  {
    path: '/admin/numbers',
    name: 'Numbers',
    component: Numbers,
    meta: {
      title: 'titles.admin.numbers',
      requiresAuth: true,
      roles: [ 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/admin/lines',
    name: 'Lines',
    component: Lines,
    meta: {
      title: 'titles.admin.lines',
      requiresAuth: true,
      roles: [ 'GROUP_ADMIN', 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/admin/lineGroups',
    name: 'LineGroups',
    component: LineGroups,
    meta: {
      title: 'titles.admin.lineGroups',
      requiresAuth: true,
      roles: [ 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/admin/company-groups',
    name: 'CompanyGroups',
    component: CompanyGroups,
    meta: {
      title: 'titles.admin.companyGroups',
      requiresAuth: true,
      roles: [ 'SUPER_ADMIN' ]
    }
  },
  {
    path: '/admin/configuration',
    name: 'Configuration',
    component: Configuration,
    meta: {
      title: 'titles.admin.configuration',
      requiresAuth: true,
      roles: [ 'COMPANY_ADMIN' ]
    }
  },
  {
    path: '/admin/company-delegations',
    name: 'CompanyDelegations',
    component: CompanyDelegations,
    meta: {
      title: 'titles.admin.companyDelegations',
      requiresAuth: true,
      roles: [ 'COMPANY_ADMIN' ],
      ignoreDelegations: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/pages/Admin/routes.js